var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Basic = require("../../../../elements/Basic");

var _i18n = _interopRequireDefault(require("../../../../i18n"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Table/Standings/StandingsHeaderBuilder.js";

var StandingsHeaderBuilder = function StandingsHeaderBuilder() {
  return [_react.default.createElement(_Basic.Text, {
    tableWidth: 7 / 100,
    maxWidth: 45,
    columnStyling: {
      center: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6,
      columnNumber: 5
    }
  }, "#"), _react.default.createElement(_Basic.Text, {
    tableWidth: 8 / 100,
    maxWidth: 50,
    columnStyling: {
      center: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 5
    }
  }), _react.default.createElement(_Basic.Text, {
    tableWidth: 29 / 100,
    pl: 10,
    columnStyling: {
      flexing: true,
      centerVertical: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 5
    }
  }, (0, _i18n.default)('standings_header.TEAM')), _react.default.createElement(_Basic.Text, {
    tableWidth: 8 / 100,
    maxWidth: 40,
    columnStyling: {
      center: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 5
    }
  }, (0, _i18n.default)('standings_header.PLAYED')), _react.default.createElement(_Basic.Text, {
    tableWidth: 6 / 100,
    maxWidth: 40,
    columnStyling: {
      center: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 5
    }
  }, (0, _i18n.default)('standings_header.WIN')), _react.default.createElement(_Basic.Text, {
    tableWidth: 6 / 100,
    maxWidth: 40,
    columnStyling: {
      center: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 5
    }
  }, (0, _i18n.default)('standings_header.DRAW')), _react.default.createElement(_Basic.Text, {
    tableWidth: 6 / 100,
    maxWidth: 40,
    columnStyling: {
      center: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 5
    }
  }, (0, _i18n.default)('standings_header.LOOSE')), _react.default.createElement(_Basic.Text, {
    tableWidth: 14 / 100,
    maxWidth: 90,
    columnStyling: {
      center: true
    },
    numberOfLines: 1,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 5
    }
  }, (0, _i18n.default)('standings_header.GOALS')), _react.default.createElement(_Basic.Text, {
    tableWidth: 8 / 100,
    maxWidth: 40,
    columnStyling: {
      center: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 5
    }
  }, "+/-"), _react.default.createElement(_Basic.Text, {
    tableWidth: 8 / 100,
    maxWidth: 55,
    columnStyling: {
      center: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 5
    }
  }, (0, _i18n.default)('standings_header.POINTS'))];
};

var _default = StandingsHeaderBuilder;
exports.default = _default;